export default __webpack_public_path__ + "atomic/_patterns/01-atoms/form-element-textarea/_form-element-textarea.twig";